import { render, staticRenderFns } from "./PublicEvent.vue?vue&type=template&id=63b45530&scoped=true"
import script from "./PublicEvent.vue?vue&type=script&lang=js"
export * from "./PublicEvent.vue?vue&type=script&lang=js"
import style0 from "./PublicEvent.vue?vue&type=style&index=0&id=63b45530&prod&scoped=true&lang=css"
import style1 from "./PublicEvent.vue?vue&type=style&index=1&id=63b45530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b45530",
  null
  
)

export default component.exports